import { Tabs as GrommetTabs, TabsProps } from 'grommet'
import React from 'react'

const Tabs = (props: TabsProps & JSX.IntrinsicElements['div']) => {
  return <GrommetTabs {...props}>{props.children}</GrommetTabs>
}

export default Tabs
